
import styled from 'styled-components';
import TrackingComponent from '../components/Tracking/TrackingComponent';
import MarketingIntro from '../components/Marketing/MarketingIntro';
import MarketingLessWaste from '../components/Marketing/MarketingLessWaste';
import MarketingChallanges from '../components/Marketing/MarketingChallanges';
import MarketingData from '../components/Marketing/MarketingData';
import GrovsDeliver from '../components/Marketing/GrovsDeliver';
import { Helmet } from 'react-helmet-async';
import GetStartedRequestDemoSide from '../components/generic/GetStartedRequestDemoSide';
import { lightThemeColors } from '../assets/style/colors';
import { ReactComponent as GridAssetIcon } from "../assets/decorations/redBannerGridMarketingBottom.svg"


const MarketingPage = () => {


    return (
        <>
            <Helmet>
                <title>Grovs for Marketers | Launch Smarter. Convert More. Scale Faster.</title>
                <meta
                    name="description"
                    content="Grovs empowers growth marketers with no-code tools, smart links, and real-time attribution to cut waste and increase ROI—without needing developers."
                />
                <meta
                    name="keywords"
                    content="marketing attribution, mobile marketing tools, smart links, deep linking, campaign tracking, no-code marketing platform, Grovs marketing, user engagement, growth automation"
                />
                <meta name="robots" content="index, follow" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Grovs for Marketers | No-Code Growth Tools that Deliver Real Results" />
                <meta
                    property="og:description"
                    content="Launch, personalize, and optimize campaigns with Grovs. Real-time insights, smart links, and cross-app messaging built for growth marketers—at 60% less cost."
                />
                <meta property="og:url" content="https://www.grovs.io/marketing" />
                <meta
                    property="og:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/social-media-placeholder.jpg"
                />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Grovs for Marketers | Drive Growth Without Devs" />
                <meta
                    name="twitter:description"
                    content="From attribution to smart messaging—Grovs helps you turn clicks into conversions, track ROI in real-time, and scale faster with one powerful platform."
                />
                <meta
                    name="twitter:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/social-media-placeholder.jpg"
                />
            </Helmet>
            <Container>
                <MarketingIntro />
                <MarketingLessWaste />
                <MarketingChallanges />
                <MarketingData />
                <GrovsDeliver />
                <GetStartedRequestDemoSide
                    bgColor={lightThemeColors.marketingBg}
                    gradientColor={" rgba(75, 25, 58, 1)"}
                    titleStyle={{ color: lightThemeColors.lightColor }}
                    subtitleStyle={{ color: lightThemeColors.lightColorFaded7 }}
                    gridDecoration={<GridAssetIcon />}
                    primaryButtonStyle={{ color: lightThemeColors.lightColor }}
                    primaryButtonVariant={lightThemeColors.footerBg}
                    outlineButtonStyle={{
                        color: lightThemeColors.darkColor,
                        background: lightThemeColors.lightColor,
                    }}
                    outlineButtonVariant={lightThemeColors.lightColor}
                    title={"Get More Growth for Less"}
                    subtitle={`Why pay more for tools that do less? No per-event overages, no extra fees for messaging, one platform, full stack, all included. `}
                />

                <TrackingComponent />
            </Container>
        </>
    )
}
export default MarketingPage

const Container = styled.div`
  display:flex;
                flex-direction: column;
                `;
